import { type CommonTokenScopes } from '@marpla/api-sdk';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type RootState } from '../store';

type ChangeTokenModalProps = {
  requiredScopes?: CommonTokenScopes[];
  mode?: 'add' | 'edit';
  permissionId?: string;
} | null;

interface UIState {
  changeTokenModalOpen: boolean;
  changeTokenModalProps: ChangeTokenModalProps;
}

const initialState: UIState = {
  changeTokenModalOpen: false,
  changeTokenModalProps: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openChangeTokenModal: (state, action: PayloadAction<ChangeTokenModalProps>) => {
      state.changeTokenModalOpen = true;
      state.changeTokenModalProps = action.payload ?? null;
    },
    closeChangeTokenModal: (state) => {
      state.changeTokenModalOpen = false;
      state.changeTokenModalProps = null;
    },
  },
});

export const { openChangeTokenModal, closeChangeTokenModal } = uiSlice.actions;

export const selectChangeTokenModalOpen = (s: RootState): boolean => s.ui.changeTokenModalOpen;

export const selectChangeTokenModalProps = (s: RootState): ChangeTokenModalProps =>
  s.ui.changeTokenModalProps;

export default uiSlice.reducer;
